export default "__VITE_ASSET___0gulvNI__"